import { useSurveyScheduler } from "../../../hooks/useSurveyScheduler";
import { engagementTrackerProvider } from "../../../AppController";

const SurveyScheduler = () => {
  useSurveyScheduler({
    engagementTrackerProvider,
  });
  return null; // This component doesn't render anything, just runs the hook
};

export default SurveyScheduler;
